import { render, staticRenderFns } from "./AdminSiteIssues.vue?vue&type=template&id=1b5c5289"
import script from "./AdminSiteIssues.vue?vue&type=script&lang=js"
export * from "./AdminSiteIssues.vue?vue&type=script&lang=js"
import style0 from "./AdminSiteIssues.vue?vue&type=style&index=0&id=1b5c5289&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports